<template>
  <div id="app">
    <router-view style="min-height: 100%"></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
   mounted(){
   
      var fingerprint=localStorage.getItem('fingerprint');
      if(fingerprint==null){
        fingerprint=''
        for(var i=0;i<16;i++){
            
            fingerprint+=Math.floor(Math.random()*16).toString(16);//获取0-15并通过toString转16进制
            }
            console.log(fingerprint)
            localStorage.setItem('fingerprint',fingerprint)
      }

      this.getPostion()
    

    
    },
  methods: {
      getPostion(){
        return new Promise((resolve, reject) => {
          let mapObj = new AMap.Map('iCenter');
          mapObj.plugin('AMap.Geolocation', function () {
            let geolocation = new AMap.Geolocation({
              enableHighAccuracy: true,//是否使用高精度定位，默认:true
              timeout: 10000,          //超过10秒后停止定位，默认：无穷大
              maximumAge: 0,           //定位结果缓存0毫秒，默认：0
              convert: true,           //自动偏移坐标，偏移后的坐标为高德坐标，默认：true
              showButton: true,        //显示定位按钮，默认：true
              buttonPosition: 'LB',    //定位按钮停靠位置，默认：'LB'，左下角
              buttonOffset: new AMap.Pixel(10, 20),//定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
              showMarker: true,        //定位成功后在定位到的位置显示点标记，默认：true
              showCircle: true,        //定位成功后用圆圈表示定位精度范围，默认：true
              panToLocation: true,     //定位成功后将定位到的位置作为地图中心点，默认：true
              zoomToAccuracy: true      //定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
            });
            mapObj.addControl(geolocation);
            geolocation.getCurrentPosition();
            AMap.event.addListener(geolocation, 'complete', function (pos) {
              // alert(pos.formattedAddress)
                            //  console.log(pos)
              let position={
                address:pos.formattedAddress,
                lat:pos.position.lat,
                lng:pos.position.lng
              }      
              sessionStorage.setItem('pos',JSON.stringify(position)) 
              resolve(pos)
            });//返回定位信息
            AMap.event.addListener(geolocation, 'error', function (err) {
              //                console.log(err)
              reject(err);
            });      //返回定位出错信息
          });
        })
      },
  }
}
</script>

<style>
  /* http://meyerweb.com/eric/tools/css/reset/
     v2.0 | 20110126
     License: none (public domain)
  */

  html, body, div, span, applet, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  a, abbr, acronym, address, big, cite, code,
  del, dfn, em, img, ins, kbd, q, s, samp,
  small, strike, strong, sub, sup, tt, var,
  b, u, i, center,
  dl, dt, dd, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, embed,
  figure, figcaption, footer, header, hgroup,
  menu, nav, output, ruby, section, summary,
  time, mark, audio, video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    /* vertical-align: baseline; */
  }
  /* HTML5 display-role reset for older browsers */
  article, aside, details, figcaption, figure,
  footer, header, hgroup, menu, nav, section {
    display: block;
  }
  body {
    line-height: 1;
  }
  ol, ul {
    list-style: none;
  }
  blockquote, q {
    quotes: none;
  }
  blockquote:before, blockquote:after,
  q:before, q:after {
    content: '';
    content: none;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }
#app {
  font-family: 'Microsoft YaHei', arial, helvetica, sans-serif;
  height: 100%;
}
  input,button,a,select {
    outline:0 none !important; blr:expression(this.onFocus=this.blur());
  }
  .clear:after{
    content: '';
    display: block;
    clear: both;
  }
</style>



// WEBPACK FOOTER //
// App.vue?69017608